module.exports = __webpack_public_path__ + "img/bg-dashboard-pinkyellow.915fd182.png";